<template>
  <div id="app">
    <!-- <router-view :key="$route.fullPath"></router-view> -->
    <router-view />

    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
    </router-view> -->
  </div>
</template>

<script>
export default {
  // 监听,当路由发生变化的时候执行
  data () {
    return {
      scroll: 0
    }
  },
  watch: {
    $route (to, from) {
      // console.log(to)
      if (to.name === 'home') {
        document.querySelector('#float_fb_plugin').style.display = 'block'
      }else {
        document.querySelector('#float_fb_plugin').style.display = 'none'
      }

      if (to.name === 'events' || to.name === 'events-ppwc' || to.name === 'events-schedule' || to.name === 'festival' || to.name === 'festival-upcoming' || to.name === 'festival-past' || to.name === 'upcoming-activate-step1' || to.name === 'upcoming-activate-step2' || to.name === 'upcoming-activate-step3' || to.name === 'upcoming-activate-step4' || to.name === 'upcoming-activate-step5' || to.name === 'upcoming-activate-dec-step1') {
        this.$store.commit('changeTab', 1)
      } else if (to.name === 'blog' || to.name === 'blog-item') {
        this.$store.commit('changeTab', 2)
      } else {
        this.$store.commit('changeTab', 0)
      }

      if (to.name === 'item' && from.name === 'answer') {
        setTimeout(() => {
          document.querySelector('#app').scrollTop = parseInt(
            this.$store.state.scroll
          )
        }, 0)
      } else {
        document.querySelector('#app').scrollTop = 0
      }
    }
  }
}
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  font-family: 'Open Sans', "PingFang SC", Helvetica, "STHeiti STXihei", "Microsoft YaHei",
    Tohoma, Arial, sans-serif;
  background-color: #fff;
}
#app::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
#app {
  width: 10rem;
  height: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 auto;
  background-color: #fff;
  color: #727272;
}
@media only screen and (max-width: 700px) {
  html,
  body {
    background-color: #fff;
  }
}
@media only screen and (min-width: 800px) {
  body {
    font-size: 100% !important;
  }
}

#app {
  // overflow:hidden;/* winphone8和android4+ */
  -webkit-overflow-scrolling: touch; /* ios5+ */
}
#app:after {
  min-height: calc(100% + 1px);
}

p {
  margin: 0;
  padding: 0;
  word-wrap: break-word;
  font-size: 28px;
  line-height: 32px;
}
a {
  font-size: 28px;
  text-decoration: none !important;
}
.disnone {
  display: none;
}
.van-dialog {
  width: 288px;
}

.center {
  text-align: center;
}

//全局样式
.black_bg {
  background-color: #100e0f;
}
.green_bg {
  background-color: #289753;
}
.primary_title_color {
  color: #269853;
}
.primary_color {
  color: #289753;
}
.regular_title_color {
  color: #a6a6a6;
}
.regular_color {
  color: #727272;
}
.divider_color {
  position: relative;
  background-color: #e4e4e4;
  width: 100%;
  height: 26px;
}

//vant 的自定义样式
.van-tabs__line {
  width: 44px !important;
  height: 6px !important;
  border-radius: 0px !important;
}
.van-tabs--line .van-tabs__wrap {
  height: 44px!important;
}
.van-tab {
  line-height: 44px!important;
}
.line {
  border-top: none !important;
  border-bottom: 2px solid#c0c0c0 !important;
  // opacity: 0.4;
}
.line.green {
  border-top: none !important;
  border-bottom: 2px solid#2e7149 !important;
}
.van-dialog {
  width: 660px !important;
}
</style>
